// If you want to log information to browser terminal and keep it on production, use logger;
export const logger = console;
